export default __webpack_public_path__ + "static/media/mapa2.c77cc85a.png";